import { AuthModel, UserModel } from '../../models'
import { removeApiToken, setApiToken, setCurrentUser } from '../slices/AuthSlice'

const user = {
    id: 2,
    first_name: 'Demo',
    username: '',
    password: '',
    last_name: 'User',
    email: 'admin@demo.com',
    email_verified_at: '2022-03-30T12:17:50.000000Z',
    created_at: '2022-03-30T12:17:50.000000Z',
    updated_at: '2022-05-31T12:01:59.000000Z',
    api_token: 'sdfsdfsd34sg456trtgfxdg',
} as UserModel

const login = (username: string, password: string) => {
    return async (dispatch: (arg0: { payload: string | UserModel; type: string }) => void) => {
        const auth: AuthModel = {
            api_token: 'sdfsdfsd34sg456trtgfxdg',
        }

        dispatch(setApiToken(auth.api_token))
        dispatch(setCurrentUser(user))
    }
}

const getCurrentUser = () => {
    return async (dispatch: (arg0: { payload: UserModel; type: string }) => void) => {
        dispatch(setCurrentUser(user))
    }
}

const logout = () => {
    return async (dispatch: (arg0: { payload: undefined; type: string }) => void) => {
        dispatch(removeApiToken())
    }
}

export { login, getCurrentUser, logout }
